var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
export const ButtonV2 = (_a) => {
    var { variant = "primary", size = "md", fullWidth = false, icon, iconPosition = "left", iconVariant = "default", className = "", children, disabled, dropdown, showDropdownIcon = false, isActive = false, isGrouped = false, groupPosition = "single" } = _a, props = __rest(_a, ["variant", "size", "fullWidth", "icon", "iconPosition", "iconVariant", "className", "children", "disabled", "dropdown", "showDropdownIcon", "isActive", "isGrouped", "groupPosition"]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const baseClasses = `inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200`;
    const variantClasses = {
        // primary: "bg-blue-600 text-white hover:bg-blue-700 shadow-sm",
        primary: "bg-gradient-to-b from-[#007BD9] to-[#005AA1] text-white hover:from-[#0070C9] hover:to-[#004F91] shadow-sm " +
            "dark:bg-gradient-to-b dark:from-[#1e293b] dark:to-[#0f172a] dark:text-white dark:hover:from-[#334155] dark:hover:to-[#1e293b]",
        // secondary: "bg-gray-800 text-white hover:bg-gray-900 shadow-sm",
        secondary: "bg-gradient-to-b from-[#F9FAFB] to-[#E2E6EA] text-gray-700 border border-[#CDD3DA] hover:from-[#F3F4F6] hover:to-[#D1D5DB] " +
            "dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:from-gray-700 dark:hover:to-gray-600",
        // outline: "bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-300",
        outline: `bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 ${isActive ? "bg-[#F1F3F5]" : ""} ` +
            "dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800",
        icon: iconVariant === "secondary"
            ? "bg-gradient-to-b from-[#F9FAFB] to-[#E2E6EA] text-gray-700 border border-[#CDD3DA] hover:from-[#F3F4F6] hover:to-[#D1D5DB] " +
                "dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:from-gray-700 dark:hover:to-gray-600"
            : "text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800",
    };
    const sizeClasses = {
        sm: variant === "icon" ? "p-1.5" : "px-3 py-1.5 text-sm",
        md: variant === "icon" ? "p-2" : "px-4 py-2 text-sm",
        lg: variant === "icon" ? "p-2.5" : "px-5 py-2.5 text-base",
    };
    const disabledClasses = disabled === true
        ? "opacity-50 cursor-not-allowed pointer-events-none"
        : "";
    const activeClasses = isActive ? "z-10 relative font-semibold" : "";
    // Handle grouped button styling
    const groupedClasses = isGrouped
        ? "focus:relative focus:z-10 border-r-0 last:border-r focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-300"
        : "rounded-lg";
    const groupPositionClasses = isGrouped
        ? {
            first: "rounded-r-none rounded-l-lg",
            middle: "rounded-none",
            last: "rounded-l-none rounded-r-lg",
            single: "rounded-lg",
        }[groupPosition]
        : "";
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const ChevronDownIcon = () => (_jsx("svg", { className: `h-4 w-4 ${variant !== "icon" ? "ml-2" : ""}`, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) }));
    return (_jsxs("div", { className: "relative inline-block", children: [_jsxs("button", Object.assign({ className: `
        ${baseClasses}
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${fullWidth ? "w-full" : ""}
        ${disabledClasses}
        ${activeClasses}
        ${groupedClasses}
        ${groupPositionClasses}
        ${className}
      `, disabled: disabled, onClick: () => dropdown !== undefined && setIsDropdownOpen(!isDropdownOpen) }, props, { children: [icon !== undefined && iconPosition === "left" && (_jsx("span", { className: variant === "icon" ? "" : "mr-2", children: icon })), variant !== "icon" && children, icon !== undefined &&
                        iconPosition === "right" &&
                        variant !== "icon" && _jsx("span", { className: "ml-2", children: icon }), showDropdownIcon && _jsx(ChevronDownIcon, {})] })), dropdown !== undefined && isDropdownOpen && (_jsx("div", { className: "absolute z-10 mt-2 w-max min-w-full rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-gray-900 dark:text-gray-200", children: dropdown }))] }));
};
export default ButtonV2;
